import Enums from "@/enums/enums";
import userInfo from "@/function/userInfo";
import packageHelper from "@/helper/packagehelper";
import tableHelper from "@/helper/tableHelper";

//#region transactionInputFunction
function TransactionSearchCriteria(input) {
  let transactionSearchCriteria = {
    searchText: input ? input.searchText : "",
    datetype: 0,
    fromDate: input ? input.fromDate : null,
    toDate: input ? input.toDate : null,
    fromNetAmount: null,
    toNetAmount: null,
    isShowDeleted: input ? input.isShowDeleted : false,
  };

  return transactionSearchCriteria;
}
function ImportTableView(input) {
  let ImportTableView = {
    tableStatus: input ? input.tableStatus : 0,
    tableSorting: input ? input.tableSorting : 0,
    importTableView: input ? input.importTableView : 0,
    pageNo: input ? input.pageNo : 1,
    pageSize: input ? input.pageSize : 10,
    searchText: input ? input.searchText : "",
    orderText: "id DESC",
  };

  return ImportTableView;
}
function GetUpdateSettingTableRequest(input, documentType) {
  const tableViewType = tableHelper.GetConvertedSettingTableSortColumnToTableView(input.sortColumnType, documentType);

  return {
    issuedDatePeriodType: input.issuedDatePeriodType,
    tableViewType: tableViewType,
  };
}
//#endregion

//#region transactionTableOutputFunction
function RecurringTableListModel(transactionList) {
  let transactionModel = [];
  if (transactionList !== null) {
    for (let count = 0; count < transactionList.length; count++) {
      let transactionItem = transactionList[count];
      let transaction = {
        id: transactionItem.id,
        number: transactionItem.number,
        contactId: transactionItem.contactId,
        transactionNetAmount: transactionItem.transactionNetAmount,
        isArchived: transactionItem.isArchived,
        periodType: transactionItem.periodType,
        everyXDay: transactionItem.everyXDay,
        day: transactionItem.day,
        week: transactionItem.week,
        date: transactionItem.date,
        month: transactionItem.month,
        status: transactionItem.status,
        createdTransactionAsStatus: transactionItem.createdTransactionAsStatus,
        recurringNextTime: transactionItem.recurringNextTime,
      };
      transactionModel.push(transaction);
    }
  }
  return transactionModel;
}
function GetSettingTableOutput(_settingTable, documentType) {
  const sortColumnType = tableHelper.GetConvertedTableViewToSettingTableSortColumn(
    _settingTable.tableViewType,
    documentType
  );

  return {
    issuedDatePeriodType: _settingTable.issuedDatePeriodType,
    sortColumnType: sortColumnType,
  };
}
//#endregion

function ImportListToImportTableList(_importList) {
  let importList = [];
  _importList.forEach((importData, index) => {
    let importModel = {
      id: importData.id,
      uuid: importData.uuid,
      code: importData.code,
      approvedDate: importData.approvedDate ? importData.approvedDate.NewDateTimeUctToTimezone() : "",
      createdDateTime: importData.createdDateTime.NewDateTimeUctToTimezone(),
      approvedUserId: importData.approvedUserId,
      userId: importData.userId,
      userDisplayName: importData.userDisplayName,
      transactionType: importData.transactionType,
      financeType: importData.financeType,
      expenseType: importData.expenseType,
      importStatus: importData.importStatus,
      importType: importData.importType,
      transactionCount: importData.transactionCount,
      isDeleted: importData.isDeleted,
      importTransactionType: importData.importTransactionType,
    };
    importList.push(importModel);
  });
  return importList;
}
function ImportCountToImportTableCount(_importCount) {
  let model = {
    all: _importCount.all,
    quotation: _importCount.quotation,
    invoice: _importCount.invoice,
    receipt: _importCount.receipt,
    purchaseOrder: _importCount.purchaseOrder,
    purchaseInventory: _importCount.purchaseInventory,
    expense: _importCount.expense,
    voided: _importCount.voided,
    receiptFromInvoice: _importCount.receiptFromInvoice,
    receiptFromQuotation: _importCount.receiptFromQuotation,
    invoiceFromQuotation: _importCount.invoiceFromQuotation,
    journal: _importCount.journal,
  };
  return model;
}
function TransactionSummaryModel(transactionSummary) {
  let transactionSummaryModel = {
    netAmount: transactionSummary.netAmount,
    preVatTotal: transactionSummary.preVatTotal,
    remainPaymentNetAmount: transactionSummary.remainPaymentNetAmount,
    remainWhtPaymentNetAmount: transactionSummary.remainWhtPaymentNetAmount,
    subTotal: transactionSummary.subTotal,
    subTotalForCalculateWht: transactionSummary.subTotalForCalculateWht,
    vatExemptedTotal: transactionSummary.vatExemptedTotal,
    vatTotal: transactionSummary.vatTotal,
    whtTotal: transactionSummary.whtTotal,
    zeroVatTotal: transactionSummary.zeroVatTotal,
    sameProductVatType: transactionSummary.sameProductVatType,
  };
  return transactionSummaryModel;
}
function GetGroupListByContactTable(id, contactGroupList) {
  let contactGroupTableList = [];
  if (contactGroupList && contactGroupList.length > 0) {
    contactGroupList.forEach((contactGroupTable) => {
      if (contactGroupTable.contactId === id) {
        contactGroupTableList.push({
          name: contactGroupTable.groupName,
          contactGroupId: contactGroupTable.contactGroupId,
          color: contactGroupTable.color,
        });
      }
    });
    contactGroupTableList.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
  return contactGroupTableList;
}

//#region Invoice
function GetInvoiceTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    isAllFixAssetTemplateSearch: null,
    assetTemplateIdList: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetInvoiceTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    isAllFixAssetTemplateSearch: null,
    assetTemplateIdList: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetInvoiceTableRequest(input) {
  let data = GetInvoiceTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetInvoiceTableAdvanceSearchRequest(input) {
  let data = GetInvoiceTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetInvoiceTableVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}

function GetExpenseTableVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}

function GetPurchaseAssetTableVeryAdvanceSearchRequest(input) {
  let data = GetExpenseTableVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetInvoiceTableCountRequest(input) {
  let data = GetInvoiceTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetInvoiceTableCountAdvanceSearchRequest(input) {
  let data = GetInvoiceTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetInvoiceTableCountVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetExpenseTableCountVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableCountVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}

function GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input) {
  let data = GetExpenseTableCountVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}

function GetInvoiceTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
        vatTotal: tableItem.vatTotal,
        preVatTotal: tableItem.preVatTotal,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
        taxInvoiceIssuedReceivedModelList: null,
        remainPayment: 0,
        referenceReceiptId: 0,
        receiptCreateStatus: 0,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function GetLastestInvoiceId(invoiceNumberList) {
  if (invoiceNumberList && invoiceNumberList.length > 0) {
    return invoiceNumberList[invoiceNumberList.length - 1].invoiceId;
  }
  return 0;
}
//#endregion
//#region Quotation
function GetQuotationTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    assetTemplateIdList: null,
    isAllFixAssetTemplateSearch: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetQuotationTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    assetTemplateIdList: null,
    isAllFixAssetTemplateSearch: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetQuotationTableRequest(input) {
  let data = GetQuotationTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetQuotationTableAdvanceSearchRequest(input) {
  let data = GetQuotationTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromActionDate = input.searchAdvance.fromAcceptedDate;
  data.toActionDate = input.searchAdvance.toAcceptedDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetQuotationTableVeryAdvanceSearchRequest(input) {
  let data = GetQuotationTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetQuotationTableCountRequest(input) {
  let data = GetQuotationTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetQuotationTableCountAdvanceSearchRequest(input) {
  let data = GetQuotationTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromActionDate = input.searchAdvance.fromAcceptedDate;
  data.toActionDate = input.searchAdvance.toAcceptedDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetQuotationTableCountVeryAdvanceSearchRequest(input) {
  let data = GetQuotationTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetQuotationTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        actionDate: tableItem.actionDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        vatTotal: tableItem.vatTotal,
        preVatTotal: tableItem.preVatTotal,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
        toCurrencyUid: tableItem.toCurrencyUid,
        referenceTransactionToCurrencyNetTotal: tableItem.referenceTransactionToCurrencyNetTotal,
        quotationReferenceTransactionType: tableItem.quotationReferenceTransactionType,
        isServiceOnly: tableItem.isServiceOnly,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function GetQuotationReferenceInvoiceListOutput(_quotationReferenceInvoiceList) {
  let quotationReferenceInvoiceList = [];
  if (_quotationReferenceInvoiceList && _quotationReferenceInvoiceList.length > 0) {
    for (let _quotationReferenceInvoice of _quotationReferenceInvoiceList) {
      quotationReferenceInvoiceList.push({
        quotationId: _quotationReferenceInvoice.quotationId,
        invoiceNumberList: _quotationReferenceInvoice.invoiceNumberList,
        lastestInvoiceId: GetLastestInvoiceId(_quotationReferenceInvoice.invoiceNumberList),
      });
    }
  }
  return quotationReferenceInvoiceList;
}
//#endregion
//#region PurchaseOrder
function GetPurchaseOrderTableAdvanceSearchRequest(input) {
  let data = GetQuotationTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}

function GetPurchaseOrderTableVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}

function GetPurchaseOrderTableCountAdvanceSearchRequest(input) {
  let data = GetQuotationTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}

function GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
//#endregion

//#region PurchaseOrderAsset
function GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  return data;
}

function GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  return data;
}
//#endregion

//#region Receipt
function GetReceiptTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetReceiptTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetReceiptTableRequest(input) {
  let data = GetReceiptTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetReceiptTableAdvanceSearchRequest(input) {
  let data = GetReceiptTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceiptTableVeryAdvanceSearchRequest(input) {
  let data = GetReceiptTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetReceiptTableCountRequest(input) {
  let data = GetReceiptTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetReceiptTableCountAdvanceSearchRequest(input) {
  let data = GetReceiptTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceiptTableCountVeryAdvanceSearchRequest(input) {
  let data = GetReceiptTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetReceiptTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
        vatTotal: tableItem.vatTotal,
        preVatTotal: tableItem.preVatTotal,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
//#endregion
//#region TaxInvoice
function GetTaxInvoiceTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    filterETaxInvoiceType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetTaxInvoiceTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    filterETaxInvoiceType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetTaxInvoiceTableRequest(input) {
  let data = GetTaxInvoiceTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.filterETaxInvoiceType = input.filterETaxInvoiceType;
  return data;
}
function GetTaxInvoiceTableAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetTaxInvoiceTableVeryAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetTaxInvoiceTableCountRequest(input) {
  let data = GetTaxInvoiceTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.filterETaxInvoiceType = input.filterETaxInvoiceType;
  return data;
}
function GetTaxInvoiceTableCountAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetTaxInvoiceTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    transactionList = tableList.map((tableItem) => ({
      id: tableItem.isAutoGenerated ? tableItem.referenceTransactionId : tableItem.id,
      transactionType: tableItem.isAutoGenerated
        ? tableItem.referenceTransactionType
        : Enums.TransactionType.TaxInvoice,
      number: tableItem.number,
      date: tableItem.date,
      contactId: tableItem.contactId,
      transactionVat:
        (tableItem.referenceTransactionType == Enums.TransactionType.CreditNote ? -1 : 1) * tableItem.vatTotal,
      transactionNetAmount:
        (tableItem.referenceTransactionType == Enums.TransactionType.CreditNote ? -1 : 1) * tableItem.netAmount,
      status: tableItem.status,
      taxInvoiceId: tableItem.id,
      transactionItemType: tableItem.transactionItemType,
      eTaxInvoiceId: tableItem.eTaxInvoiceId,
    }));
  }
  return transactionList;
}
//#endregion
//#region CreditNote
function GetCreditNoteTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetCreditNoteTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
    receivedTaxInvoiceJournalDate: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetCreditNoteTableRequest(input) {
  let data = GetCreditNoteTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetCreditNoteTableAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetCreditNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  data.receivedTaxInvoiceJournalDate = input.searchAdvance.receivedTaxInvoiceJournalDate;
  return data;
}
function GetCreditNoteTableCountRequest(input) {
  let data = GetCreditNoteTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetCreditNoteTableCountAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetCreditNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableCountVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  data.receivedTaxInvoiceJournalDate = input.searchAdvance.receivedTaxInvoiceJournalDate;
  return data;
}
function GetCreditNoteTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
//#endregion
//#region DebitNote
function GetDebitNoteTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
    receivedTaxInvoiceJournalDate: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetDebitNoteTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
    receivedTaxInvoiceJournalDate: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetDebitNoteTableRequest(input) {
  let data = GetDebitNoteTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetDebitNoteTableAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetDebitNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  data.receivedTaxInvoiceJournalDate = input.searchAdvance.receivedTaxInvoiceJournalDate;

  return data;
}
function GetDebitNoteTableCountRequest(input) {
  let data = GetDebitNoteTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetDebitNoteTableCountAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetDebitNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableCountVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  data.receivedTaxInvoiceJournalDate = input.searchAdvance.receivedTaxInvoiceJournalDate;

  return data;
}
function GetDebitNoteTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
//#endregion
//#region BillingNote
function GetBillingNoteTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetBillingNoteTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
  };
}
function GetBillingNoteTableRequest(input) {
  let data = GetBillingNoteTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetBillingNoteTableAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetBillingNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableAdvanceSearchRequest(input);
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetBillingNoteTableCountRequest(input) {
  let data = GetBillingNoteTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetBillingNoteTableCountAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetBillingNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableCountAdvanceSearchRequest(input);
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  return data;
}
function GetBillingNoteTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        transactionTableStatus: ConverBillingNoteStatusToTransactionTableStatus(tableItem.status),
        referenceReceiptId: 0,
        receiptCreateStatus: 0,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function ConverBillingNoteStatusToTransactionTableStatus(billingNoteStatus) {
  switch (billingNoteStatus) {
    case Enums.BillingNoteStatus.Draft:
      return Enums.TransactionTableViewStatusType.Draft;
    case Enums.BillingNoteStatus.AwaitApproval:
      return Enums.TransactionTableViewStatusType.AwaitApproval;
    case Enums.BillingNoteStatus.Outstanding:
      return Enums.TransactionTableViewStatusType.WaitingPayment;
    case Enums.BillingNoteStatus.Overdue:
      return Enums.TransactionTableViewStatusType.OverDue;
    case Enums.BillingNoteStatus.PaidOrAwaitReceipt:
      return Enums.TransactionTableViewStatusType.Paid;
    case Enums.BillingNoteStatus.Voided:
      return Enums.TransactionTableViewStatusType.Voided;
  }
  return Enums.TransactionTableViewStatusType.All;
}
//#endregion
//#region product
//#region account
function GetJournalTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    journalTableView: null,
    journalReasonFilterTypeList: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    journalTableType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
    fromReviewedDate: null,
    toReviewedDate: null,
  };
}
function GetJournalTableCountRequestModel() {
  return {
    tableStatus: null,
    journalTableType: null,
    journalReasonFilterTypeList: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    fromCreatedDate: null,
    toCreatedDate: null,
    fromApprovedDate: null,
    toApprovedDate: null,
    fromReviewedDate: null,
    toReviewedDate: null,
  };
}
function GetJournalTableRequest(input) {
  let data = GetJournalTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.journalTableView = input.journalTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.journalTableType = input.journalTableType;
  data.journalReasonFilterTypeList = input.journalReasonFilterTypeList;
  return data;
}
function GetJournalTableAdvanceSearchRequest(input) {
  let data = GetJournalTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.searchDescription = input.searchAdvance.searchTextTransactionDescription;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetJournalTableVeryAdvanceSearchRequest(input) {
  let data = GetJournalTableAdvanceSearchRequest(input);
  data.journalAccountDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.reviewedUserId = input.searchAdvance.reviewedUserId;
  data.accountId = input.searchAdvance.accountId;
  data.journalAccountReferenceId = input.searchAdvance.accountReferenceId;
  data.journalAccountReferenceTypeId = input.searchAdvance.accountReferenceType;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  data.fromReviewedDate = input.searchAdvance.fromReviewedDate;
  data.toReviewedDate = input.searchAdvance.toReviewedDate;
  return data;
}
function GetJournalTableCountRequest(input) {
  let data = GetJournalTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.journalTableType = input.journalTableType;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.journalReasonFilterTypeList = input.journalReasonFilterTypeList;
  return data;
}
function GetJournalTableCountAdvanceSearchRequest(input) {
  let data = GetJournalTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.searchDescription = input.searchAdvance.searchTextTransactionDescription;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetJournalTableCountVeryAdvanceSearchRequest(input) {
  let data = GetJournalTableCountAdvanceSearchRequest(input);
  data.journalAccountDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.reviewedUserId = input.searchAdvance.reviewedUserId;
  data.accountId = input.searchAdvance.accountId;
  data.journalAccountReferenceId = input.searchAdvance.accountReferenceId;
  data.journalAccountReferenceTypeId = input.searchAdvance.accountReferenceType;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  data.fromCreatedDate = input.searchAdvance.fromCreatedDate;
  data.toCreatedDate = input.searchAdvance.toCreatedDate;
  data.fromApprovedDate = input.searchAdvance.fromApprovedDate;
  data.toApprovedDate = input.searchAdvance.toApprovedDate;
  data.fromReviewedDate = input.searchAdvance.fromReviewedDate;
  data.toReviewedDate = input.searchAdvance.toReviewedDate;
  return data;
}
function GetJournalTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        actionDate: tableItem.actionDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
        type: tableItem.type,
        totalCredit: tableItem.totalCredit,
        totalDebit: tableItem.totalDebit,
        validationStatus: tableItem.validationStatus,
        isDeleted: tableItem.isDeleted,
        description: tableItem.description,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function GetStockActivityTableRequest(_input) {
  let input = {
    productTemplateId: _input.productId,
    fromDate: _input.fromDate,
    toDate: _input.toDate,
    searchText: _input.searchText,
    pageNo: _input.pageNo,
    pageSize: _input.pageSize,
    isGetBeginingBalance: _input.isGetBeginingBalance,
    isUseMainDatabase: _input.isUseMainDatabase,
  };
  return input;
}

function GetStockActivityTableCountRequest(_input) {
  let input = {
    productTemplateId: _input.productId,
    fromDate: _input.fromDate,
    toDate: _input.toDate,
    searchText: _input.searchText,
    isUseMainDatabase: _input.isUseMainDatabase,
  };
  return input;
}
function GetStockActivityTableOutput(tableList, isShowRemain) {
  let stockActivityTableList = [];
  if (tableList && tableList.length > 0) {
    tableList.forEach((table) => {
      stockActivityTableList.push({
        amount: table.amount,
        contactId: table.contactId,
        date: table.date,
        financeType: table.financeType,
        id: table.id,
        isAdjust: table.isAdjust,
        price: table.price,
        stockAdjustmentType: table.stockAdjustmentType,
        transactionId: table.transactionId,
        transactionNumber: table.transactionNumber,
        transactionType: table.transactionType,
        remain: table.remain,
        total: table.total,
        isBeginingBalanceFromTable: table.isBeginingBalanceFromTable,
        stockMovementTableType: table.stockMovementTableType,
        isShowRemain: isShowRemain,
      });
    });
  }
  return stockActivityTableList;
}
function GetLotTableOutput(lot) {
  if (lot && lot.sequenceNumber > 0) {
    let total = 0;
    const tableList = [];
    if (lot.lotMovementTableList && lot.lotMovementTableList.length > 0) {
      for (const lotMovement of lot.lotMovementTableList) {
        const number = lotMovement.isAdjustAmount ? lotMovement.journalNumber : lotMovement.transactionNumber;
        total++;
        tableList.push({
          sequenceNumber: lotMovement.sequenceNumber,
          type: lotMovement.type,
          stockActivityId: lotMovement.stockActivityId,
          date: lotMovement.date,
          amount: lotMovement.amount,
          cost: lotMovement.cost,
          totalCost: lotMovement.totalCost,
          remainAmount: lotMovement.remainAmount,
          remainCost: lotMovement.remainCost,
          contactId: lotMovement.contactId,
          contactName: "",
          transactionId: lotMovement.transactionId,
          transactionType: lotMovement.transactionType,
          financeType: lotMovement.financeType,
          transactionNumber: lotMovement.transactionNumber,
          journalId: lotMovement.journalId,
          journalNumber: lotMovement.journalNumber,
          isAdjustAmount: lotMovement.isAdjustAmount,
          number: number,
        });
      }
    }
    return {
      sequenceNumber: lot.sequenceNumber,
      date: lot.date,
      number: lot.number,
      costPerUnit: lot.costPerUnit,
      remainAmount: lot.remainAmount,
      remainCost: lot.remainCost,
      total: total,
      tableList: tableList,
    };
  }
  return null;
}
//#endregion
//#region PurchaseRequisition
export const GetPurchaseRequisitionTableListOutput = (tableListRaw) => {
  const tableList = [];
  if (tableListRaw && tableListRaw.length > 0) {
    for (const tableRaw of tableListRaw) {
      const table = {
        id: tableRaw.id,
        date: tableRaw.date,
        dueDate: tableRaw.dueDate,
        acceptTaskDate: tableRaw.acceptTaskDate,
        status: tableRaw.status,
        number: tableRaw.number,
        contactId: tableRaw.contactId,
        toCurrencyNetTotal: tableRaw.toCurrencyNetTotal,
        fromCurrencyNetTotal: tableRaw.fromCurrencyNetTotal,
        fromCurrencyUId: tableRaw.fromCurrencyUId,
        toCurrencyUId: tableRaw.toCurrencyUId,
        isAllocation: tableRaw.isAllocation,
        createdUserId: tableRaw.createdUserId,
        approvedUserId: tableRaw.approvedUserId,
        referenceName: tableRaw.referenceName,
        approvedDateTime: tableRaw.approvedDateTime,
        createdDateTime: tableRaw.createdDateTime,
      };
      tableList.push(table);
    }
  }
  return tableList;
};

export const GetPurchaseRequisitionItemForSearchListOutput = (purchaseRequisitionItemListRaw) => {
  const transactionMap = new Map();
  if (purchaseRequisitionItemListRaw && purchaseRequisitionItemListRaw.length > 0) {
    for (const purchaseRequisitionItemRaw of purchaseRequisitionItemListRaw) {
      if (transactionMap.has(purchaseRequisitionItemRaw.id)) {
        const transactionItemList = transactionMap.get(purchaseRequisitionItemRaw.id);
        transactionItemList.push({
          description: purchaseRequisitionItemRaw.description,
          productTemplateId: purchaseRequisitionItemRaw.productTemplateId,
        });
      } else {
        transactionMap.set(purchaseRequisitionItemRaw.id, [
          {
            description: purchaseRequisitionItemRaw.description,
            productTemplateId: purchaseRequisitionItemRaw.productTemplateId,
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, transactionItemList]) => ({
    transactionId,
    transactionItemList,
  }));
};

export const GetPurchaseRequisitionAllocationItemForTableListOutput = (purchaseRequisitionItemListRaw) => {
  const transactionMap = new Map();
  if (purchaseRequisitionItemListRaw && purchaseRequisitionItemListRaw.length > 0) {
    for (const purchaseRequisitionItemRaw of purchaseRequisitionItemListRaw) {
      if (transactionMap.has(purchaseRequisitionItemRaw.id)) {
        const allocationList = transactionMap.get(purchaseRequisitionItemRaw.id);
        const allocation = allocationList.find((x) => x.allocationId === purchaseRequisitionItemRaw.allocationId);
        if (allocation) {
          allocation.allocationItemList.push(purchaseRequisitionItemRaw.allocationItemId);
        } else {
          allocationList.push({
            allocationId: purchaseRequisitionItemRaw.allocationId,
            allocationItemList: [purchaseRequisitionItemRaw.allocationItemId],
          });
        }
      } else {
        transactionMap.set(purchaseRequisitionItemRaw.id, [
          {
            allocationId: purchaseRequisitionItemRaw.allocationId,
            allocationItemList: [purchaseRequisitionItemRaw.allocationItemId],
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, allocationList]) => ({
    transactionId,
    allocationList,
  }));
};
//#endregion
//#region Deposit
function GetDepositTableListOutput(tableListRaw) {
  const tableList = [];
  if (tableListRaw && tableListRaw.length > 0) {
    for (const tableRaw of tableListRaw) {
      const table = {
        id: tableRaw.id,
        date: tableRaw.date,
        dueDate: tableRaw.dueDate,
        status: tableRaw.status,
        number: tableRaw.number,
        contactId: tableRaw.contactId,
        toCurrencyNetTotal: tableRaw.toCurrencyNetTotal,
        fromCurrencyNetTotal: tableRaw.fromCurrencyNetTotal,
        fromCurrencyUId: tableRaw.fromCurrencyUId,
        toCurrencyUId: tableRaw.toCurrencyUId,
        isAllocation: tableRaw.isAllocation,
        createdUserId: tableRaw.createdUserId,
        approvedUserId: tableRaw.approvedUserId,
        referenceName: tableRaw.referenceName,
        referenceTransactionId: tableRaw.referenceTransactionId,
        referenceTransactionType: tableRaw.referenceTransactionType,
        approvedDateTime: tableRaw.approvedDateTime,
        createdDateTime: tableRaw.createdDateTime,
      };
      tableList.push(table);
    }
  }
  return tableList;
}

export const GetDepositItemForSearchListOutput = (depositItemListRaw) => {
  const transactionMap = new Map();
  if (depositItemListRaw && depositItemListRaw.length > 0) {
    for (const depositItemRaw of depositItemListRaw) {
      if (transactionMap.has(depositItemRaw.id)) {
        const transactionItemList = transactionMap.get(depositItemRaw.id);
        transactionItemList.push({
          description: depositItemRaw.description,
          productTemplateId: depositItemRaw.productTemplateId,
        });
      } else {
        transactionMap.set(depositItemRaw.id, [
          {
            description: depositItemRaw.description,
            productTemplateId: depositItemRaw.productTemplateId,
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, transactionItemList]) => ({
    transactionId,
    transactionItemList,
  }));
};

export const GetDepositAllocationItemForTableListOutput = (depositItemListRaw) => {
  const transactionMap = new Map();
  if (depositItemListRaw && depositItemListRaw.length > 0) {
    for (const depositItemRaw of depositItemListRaw) {
      if (transactionMap.has(depositItemRaw.id)) {
        const allocationList = transactionMap.get(depositItemRaw.id);
        const allocation = allocationList.find((x) => x.allocationId === depositItemRaw.allocationId);
        if (allocation) {
          allocation.allocationItemList.push(depositItemRaw.allocationItemId);
        } else {
          allocationList.push({
            allocationId: depositItemRaw.allocationId,
            allocationItemList: [depositItemRaw.allocationItemId],
          });
        }
      } else {
        transactionMap.set(depositItemRaw.id, [
          {
            allocationId: depositItemRaw.allocationId,
            allocationItemList: [depositItemRaw.allocationItemId],
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, allocationList]) => ({
    transactionId,
    allocationList,
  }));
};
//#endregion
//#region GoodsReceipt
export const GetGoodsReceiptTableListOutput = (tableListRaw) => {
  const tableList = [];
  if (tableListRaw && tableListRaw.length > 0) {
    for (const tableRaw of tableListRaw) {
      const table = {
        id: tableRaw.id,
        date: tableRaw.date,
        status: tableRaw.status,
        number: tableRaw.number,
        contactId: tableRaw.contactId,
        toCurrencyNetTotal: tableRaw.toCurrencyNetTotal,
        fromCurrencyNetTotal: tableRaw.fromCurrencyNetTotal,
        fromCurrencyUId: tableRaw.fromCurrencyUId,
        toCurrencyUId: tableRaw.toCurrencyUId,
        isAllocation: tableRaw.isAllocation,
        createdUserId: tableRaw.createdUserId,
        approvedUserId: tableRaw.approvedUserId,
        referenceName: tableRaw.referenceName,
        referenceTransactionId: tableRaw.referenceTransactionId,
        referenceTransactionType: tableRaw.referenceTransactionType,
        approvedDateTime: tableRaw.approvedDateTime,
        createdDateTime: tableRaw.createdDateTime,
      };
      tableList.push(table);
    }
  }
  return tableList;
};

export const GetGoodsReceiptItemForSearchListOutput = (goodsReceiptItemListRaw) => {
  const transactionMap = new Map();
  if (goodsReceiptItemListRaw && goodsReceiptItemListRaw.length > 0) {
    for (const goodsReceiptItemRaw of goodsReceiptItemListRaw) {
      if (transactionMap.has(goodsReceiptItemRaw.id)) {
        const transactionItemList = transactionMap.get(goodsReceiptItemRaw.id);
        transactionItemList.push({
          description: goodsReceiptItemRaw.description,
          productTemplateId: goodsReceiptItemRaw.productTemplateId,
        });
      } else {
        transactionMap.set(goodsReceiptItemRaw.id, [
          {
            description: goodsReceiptItemRaw.description,
            productTemplateId: goodsReceiptItemRaw.productTemplateId,
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, transactionItemList]) => ({
    transactionId,
    transactionItemList,
  }));
};

export const GetGoodsReceiptAllocationItemForTableListOutput = (goodsReceiptItemListRaw) => {
  const transactionMap = new Map();
  if (goodsReceiptItemListRaw && goodsReceiptItemListRaw.length > 0) {
    for (const goodsReceiptItemRaw of goodsReceiptItemListRaw) {
      if (transactionMap.has(goodsReceiptItemRaw.id)) {
        const allocationList = transactionMap.get(goodsReceiptItemRaw.id);
        const allocation = allocationList.find((x) => x.allocationId === goodsReceiptItemRaw.allocationId);
        if (allocation) {
          allocation.allocationItemList.push(goodsReceiptItemRaw.allocationItemId);
        } else {
          allocationList.push({
            allocationId: goodsReceiptItemRaw.allocationId,
            allocationItemList: [goodsReceiptItemRaw.allocationItemId],
          });
        }
      } else {
        transactionMap.set(goodsReceiptItemRaw.id, [
          {
            allocationId: goodsReceiptItemRaw.allocationId,
            allocationItemList: [goodsReceiptItemRaw.allocationItemId],
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, allocationList]) => ({
    transactionId,
    allocationList,
  }));
};
//#endregion
//#region InvoiceReceipt
export const GetInvoiceReceiptTableListOutput = (tableListRaw) => {
  const tableList = [];
  if (tableListRaw && tableListRaw.length > 0) {
    for (const tableRaw of tableListRaw) {
      const table = {
        id: tableRaw.id,
        date: tableRaw.date,
        dueDate: tableRaw.dueDate,
        status: tableRaw.status,
        number: tableRaw.number,
        contactId: tableRaw.contactId,
        toCurrencyNetTotal: tableRaw.toCurrencyNetTotal,
        fromCurrencyNetTotal: tableRaw.fromCurrencyNetTotal,
        fromCurrencyUId: tableRaw.fromCurrencyUId,
        toCurrencyUId: tableRaw.toCurrencyUId,
        isAllocation: tableRaw.isAllocation,
        createdUserId: tableRaw.createdUserId,
        approvedUserId: tableRaw.approvedUserId,
        referenceName: tableRaw.referenceName,
        referenceTransactionId: tableRaw.referenceTransactionId,
        referenceTransactionType: tableRaw.referenceTransactionType,
        approvedDateTime: tableRaw.approvedDateTime,
        createdDateTime: tableRaw.createdDateTime,
        fromCurrencyDepositPreVatTotal: tableRaw.fromCurrencyDepositPreVatTotal,
        fromCurrencyDepositVatExemptedTotal: tableRaw.fromCurrencyDepositVatExemptedTotal,
        fromCurrencyDepositVatTotal: tableRaw.fromCurrencyDepositVatTotal,
        fromCurrencyDepositZeroVatTotal: tableRaw.fromCurrencyDepositZeroVatTotal,
        toCurrencyDepositPreVatTotal: tableRaw.toCurrencyDepositPreVatTotal,
        toCurrencyDepositVatExemptedTotal: tableRaw.toCurrencyDepositVatExemptedTotal,
        toCurrencyDepositVatTotal: tableRaw.toCurrencyDepositVatTotal,
        toCurrencyDepositZeroVatTotal: tableRaw.toCurrencyDepositZeroVatTotal,
      };
      tableList.push(table);
    }
  }
  return tableList;
};

export const GetInvoiceReceiptItemForSearchListOutput = (invoiceReceiptItemListRaw) => {
  const transactionMap = new Map();
  if (invoiceReceiptItemListRaw && invoiceReceiptItemListRaw.length > 0) {
    for (const invoiceReceiptItemRaw of invoiceReceiptItemListRaw) {
      if (transactionMap.has(invoiceReceiptItemRaw.id)) {
        const transactionItemList = transactionMap.get(invoiceReceiptItemRaw.id);
        transactionItemList.push({
          description: invoiceReceiptItemRaw.description,
          productTemplateId: invoiceReceiptItemRaw.productTemplateId,
        });
      } else {
        transactionMap.set(invoiceReceiptItemRaw.id, [
          {
            description: invoiceReceiptItemRaw.description,
            productTemplateId: invoiceReceiptItemRaw.productTemplateId,
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, transactionItemList]) => ({
    transactionId,
    transactionItemList,
  }));
};

export const GetInvoiceReceiptAllocationItemForTableListOutput = (invoiceReceiptItemListRaw) => {
  const transactionMap = new Map();
  if (invoiceReceiptItemListRaw && invoiceReceiptItemListRaw.length > 0) {
    for (const invoiceReceiptItemRaw of invoiceReceiptItemListRaw) {
      if (transactionMap.has(invoiceReceiptItemRaw.id)) {
        const allocationList = transactionMap.get(invoiceReceiptItemRaw.id);
        const allocation = allocationList.find((x) => x.allocationId === invoiceReceiptItemRaw.allocationId);
        if (allocation) {
          allocation.allocationItemList.push(invoiceReceiptItemRaw.allocationItemId);
        } else {
          allocationList.push({
            allocationId: invoiceReceiptItemRaw.allocationId,
            allocationItemList: [invoiceReceiptItemRaw.allocationItemId],
          });
        }
      } else {
        transactionMap.set(invoiceReceiptItemRaw.id, [
          {
            allocationId: invoiceReceiptItemRaw.allocationId,
            allocationItemList: [invoiceReceiptItemRaw.allocationItemId],
          },
        ]);
      }
    }
  }
  return Array.from(transactionMap, ([transactionId, allocationList]) => ({
    transactionId,
    allocationList,
  }));
};
//#endregion

//#region ProductTemplate
export const ConvertToProductTemplateTable = (transactionRawDataList) => {
  const transactionList = [];
  if (transactionRawDataList && transactionRawDataList.length > 0) {
    transactionRawDataList.forEach((table) => {
      const unit = {
        id: table.unitId,
        nameEn: table.unitNameEng,
        nameTh: table.unitNameTh,
      };
      transactionList.push({
        id: table.id,
        code: table.code,
        name: table.name,
        seletedProductUrl: table.productImageUrl,
        remainStockAmount: table.remainStockAmount,
        sellPrice: table.sellPrice,
        unit: unit,
        type: table.type,
        isArchived: table.isArchived,
      });
    });
  }
  return transactionList;
};
//#endregion

// #region Allocation
export const GetAllocationTableRequest = (input) => {
  return {
    pageNo: input.pageNo,
    pageSize: input.pageSize,
    searchText: input.searchText,
    sortingType: input.sortingType,
    allocationGroupTableView: input.allocationGroupTableView,
    isUseMainDatabase: input.isUseMainDatabase,
  };
};
// #endregion
export default {
  //#region Finance
  GetImportTableInput(input) {
    return {
      merchantId: userInfo.MerchantId(),
      importTableView: ImportTableView(input),
      isUseMainDatabase: input.isMain,
    };
  },
  GetImportTableOutput(_importTableList) {
    let importData;
    if (_importTableList !== null) {
      importData = {
        importList: ImportListToImportTableList(_importTableList.importList),
        statusCount: ImportCountToImportTableCount(_importTableList.statusCount),
      };
    }
    return importData;
  },
  GetPaymentTransferTableOutput(tableList) {
    let tableDetailList = [];
    if (tableList && tableList.length > 0) {
      for (let tableItem of tableList) {
        let item = {
          id: tableItem.id,
          paymentNumber: tableItem.number,
          createDate: tableItem.date,
          paidDate: tableItem.transferDate,
          transactionNetAmount: tableItem.netAmount,
          transactionTableStatus: tableItem.status,
          documentCount: tableItem.documentCount,
        };
        tableDetailList.push(item);
      }
    }
    return tableDetailList;
  },
  GetExpenseForCreatePaymentTransferTableOutput(tableList) {
    let tableDetailList = [];
    if (tableList && tableList.length > 0) {
      for (let tableItem of tableList) {
        let item = {
          id: tableItem.id,
          contactId: tableItem.contactId,
          contactName: tableItem.contactName,
          number: tableItem.number,
          transactionType: tableItem.transactionType,
          createDate: tableItem.createDate,
          dueDate: tableItem.dueDate,
          netAmount: tableItem.netAmount,
          remainPaymentAmount: tableItem.remainPaymentAmount,
          contactBankAccountId: tableItem.contactBankAccountId,
          contactBankReferenceBankId: tableItem.contactBankReferenceBankId,
        };
        tableDetailList.push(item);
      }
    }
    return tableDetailList;
  },
  GetExpenseDetailForCreatePaymentTransferTableOutput(tableList) {
    let tableDetailList = [];
    if (tableList && tableList.length > 0) {
      for (let tableItem of tableList) {
        let item = {
          id: tableItem.id,
          transactionNumber: tableItem.transactionNumber,
          referenceNumber: tableItem.referenceNumber,
          transactionDate: tableItem.transactionDate,
          dueDate: tableItem.dueDate,
          netAmount: tableItem.netAmount,
          paymentAmount: tableItem.paymentAmount,
          contact: {
            id: tableItem.contact.id,
            contactBranchCode: tableItem.contact.contactBranchCode,
            contactCode: tableItem.contact.contactCode,
            contactTaxId: tableItem.contact.contactTaxId,
            contactName: tableItem.contact.contactName,
            contactPhoneNumber: tableItem.contact.contactPhoneNumber,
            contactEmail: tableItem.contact.contactEmail,
            contactWebSite: tableItem.contact.contactWebSite,
            contactType: tableItem.contact.contactType,
            incomeDueDateTypeId: tableItem.contact.incomeDueDateTypeId,
            incomeDueDateDay: tableItem.contact.incomeDueDateDay,
            outflowDueDateTypeId: tableItem.contact.outflowDueDateTypeId,
            outflowDueDateDay: tableItem.contact.outflowDueDateDay,
            address: tableItem.contact.address,
            no: tableItem.contact.no,
            district1: tableItem.contact.district1,
            district2: tableItem.contact.district2,
            province: tableItem.contact.province,
            postcode: tableItem.contact.postcode,
            country: tableItem.contact.country,
            building: tableItem.contact.building,
            roomNo: tableItem.contact.roomNo,
            floorNo: tableItem.contact.floorNo,
            homeGroup: tableItem.contact.homeGroup,
            homeNo: tableItem.contact.homeNo,
            soi: tableItem.contact.soi,
            road: tableItem.contact.road,
            personFirstName: tableItem.contact.personFirstName,
            personLastName: tableItem.contact.personLastName,
            personNickName: tableItem.contact.personNickName,
            personEmail: tableItem.contact.personEmail,
            personPhone: tableItem.contact.personPhone,
            logoUrl: tableItem.contact.logoUrl,
            contactWhtType: tableItem.contact.contactWhtType,
            contactFullName: tableItem.contact.contactFullName,
            contactFullNameTh: tableItem.contact.contactFullNameTh,
            contactFullNameEng: tableItem.contact.contactFullNameEng,
            contactShortName: tableItem.contact.contactShortName,
            contactShortNameTh: tableItem.contact.contactShortNameTh,
            contactShortNameEng: tableItem.contact.contactShortNameEng,
            uuId: tableItem.contact.uuId,
            accountsPayableAccountId: tableItem.contact.accountsPayableAccountId,
            accountsReceivableAccountId: tableItem.contact.accountsReceivableAccountId,
            isDeleted: tableItem.contact.isDeleted,
            isArchived: tableItem.contact.isArchived,
            creditLimit: tableItem.contact.creditLimit,
            creditLimitSettingType: tableItem.contact.creditLimitSettingType,
            prefixNameTh: tableItem.contact.prefixNameTh,
            prefixNameEn: tableItem.contact.prefixNameEn,
            prefixNameTypeId: tableItem.contact.prefixNameTypeId,
            contactFinanceType: tableItem.contact.contactFinanceType,
          },
          contactBankInfomation: {
            id: tableItem.contactBankInfomation.id,
            bankName: tableItem.contactBankInfomation.bankName,
            accountNumber: tableItem.contactBankInfomation.accountNumber,
            accountName: tableItem.contactBankInfomation.accountName,
            branch: tableItem.contactBankInfomation.accountName,
            bankReferenceBankId: tableItem.contactBankInfomation.bankReferenceBankId,
          },
          isAllNoneOrNotSpecifyWht: tableItem.isAllNoneOrNotSpecifyWht,
          subTotalForCalculateWht: tableItem.subTotalForCalculateWht,
          whtTotal: tableItem.whtTotal,
          remainWhtAmountTotal: tableItem.remainWhtAmountTotal,
          summary: tableItem.summary,
        };
        tableDetailList.push(item);
      }
    }
    return tableDetailList;
  },
  GetCreatePaymentTransferFileOutput(paymentTransferFileInfo) {
    return {
      paymentFileId: paymentTransferFileInfo.paymentFileId,
      number: paymentTransferFileInfo.number,
      paymentFileStatus: paymentTransferFileInfo.paymentFileStatus,
    };
  },
  GetConfirmPaidPaymentTransferFileOutput(response) {
    return {
      status: response.status,
      transactionId: response.transactionId,
      transactionType: response.transactionType,
      transactionNumber: response.transactionNumber,
      paymentAmount: response.paymentAmount,
      paymentGroupId: response.paymentGroupId,
    };
  },
  GetValidateCreatePaymentOutput(validateDetail) {
    const validateCreatePaymentFileDetailResponses = [];
    if (validateDetail.validateCreatePaymentFileDetailResponses.length > 0) {
      for (let item of validateDetail.validateCreatePaymentFileDetailResponses) {
        let mapItem = {
          transactionId: item.transactionId,
          transactionType: item.transactionType,
          transactionNumber: item.transacionNumber,
          rowNumber: item.rowNumber,
          isError: item.isError,
          isWarning: item.isWarning,
          validate: item.validate,
        };
        validateCreatePaymentFileDetailResponses.push(mapItem);
      }
    }
    return {
      canCreate: validateDetail.canCreate,
      selectBankAccount: validateDetail.selectBankAccount,
      bankWorkingDay: validateDetail.bankWorkingDay,
      transferDate: validateDetail.transferDate,
      bankAccountSupportEWithholdingTax: validateDetail.bankAccountSupportEWithholdingTax,
      validateCreatePaymentFileDetailResponses: validateCreatePaymentFileDetailResponses,
    };
  },
  //#endregion
  //#region Finance
  ConvertToPaymentTransactionTable(_paymentTransactionTable) {
    return _paymentTransactionTable;
  },
  ConvertToChequeAbleToReceiveTable(_chequeTableList) {
    return _chequeTableList;
  },
  ConvertToChequeWaitingReceiveTable(_chequeTableList) {
    return _chequeTableList;
  },
  ConvertToReceivedChequeTable(_chequeTableList) {
    return _chequeTableList;
  },
  ConvertToChequeCount(_chequeCount) {
    return _chequeCount;
  },
  //#endregion
  //#region Contact
  ConvertToContactGroupList(_contactGroupList) {
    let contactTableGroupCountList = [];
    if (_contactGroupList && _contactGroupList.length > 0) {
      _contactGroupList.forEach((contactGroupItem) => {
        contactTableGroupCountList.push({
          contactGroupId: contactGroupItem.contactGroupId,
          contactGroupName: contactGroupItem.contactGroupName,
          contactGroupUUID: contactGroupItem.contactGroupUUID,
          contactGroupColor: contactGroupItem.contactGroupColor,
          contactGroupDescription: contactGroupItem.contactGroupDescription,
        });
      });
    }
    return contactTableGroupCountList;
  },
  ConvertToContactTable(_contactTable) {
    let contactTableList = [];
    let contactTableCount = _contactTable.contactTableCount ? _contactTable.contactTableCount : 0;
    if (_contactTable.contactTableList && _contactTable.contactTableList.length > 0) {
      _contactTable.contactTableList.forEach((contactTable) => {
        contactTableList.push({
          id: contactTable.id,
          uuid: contactTable.uuid,
          merchantType: contactTable.merchantType,
          contactType: contactTable.contactType,
          name: contactTable.name,
          email: contactTable.email,
          accountPayable: contactTable.accountPayable,
          accountReceivable: contactTable.accountReceivable,
          taxId: contactTable.taxId,
          branchCode: contactTable.branchCode,
          postCode: contactTable.postCode,
          country: contactTable.country,
          province: contactTable.province,
          district: contactTable.district,
          subDistrict: contactTable.subDistrict,
          address: contactTable.address,
          code: contactTable.code,
          logoUrl: contactTable.logoUrl,
          groupList: GetGroupListByContactTable(contactTable.id, _contactTable.groupList),
        });
      });
    }
    return {
      contactTableList: contactTableList,
      contactTableCount: contactTableCount,
    };
  },

  //#endregion
  //#region Product
  ConvertToProductTableCount(_productTableCount) {
    return {
      total: _productTableCount.total,
      productTotal: _productTableCount.productTotal,
      serviceTotal: _productTableCount.serviceTotal,
    };
  },
  ConvertToProductTable(_productTable) {
    let productTableList = [];
    if (_productTable.productTableList && _productTable.productTableList.length > 0) {
      _productTable.productTableList.forEach((productTable) => {
        productTableList.push({
          id: productTable.id,
          uuid: productTable.uuid,
          code: productTable.code,
          name: productTable.name,
          description: productTable.description,
          type: productTable.type,
          purchaseAvgPrice: productTable.purchaseAvgPrice,
          sellAvgPrice: productTable.sellAvgPrice,
          remainAmount: productTable.remainAmount,
          totalPurchasePrice: productTable.totalPurchasePrice,
          totalSellPrice: productTable.totalSellPrice,
          unitId: productTable.unit.id,
          unitType: productTable.unit.unitType,
          nameTh: productTable.unit.nameTh,
          nameEn: productTable.unit.nameEn,
          unitCode: productTable.unit.unitCode,
        });
      });
    }

    return productTableList;
  },
  ConvertToUnitTable(_unitTable) {
    let unitTable = {
      totalUnit: 0,
      unitList: [],
    };

    if (_unitTable.unitList.length > 0) {
      unitTable.totalUnit = _unitTable.totalUnit;
      _unitTable.unitList.forEach((unitItem) => {
        let unitModel = {
          id: unitItem.id,
          unitCode: unitItem.unitCode,
          unitType: unitItem.unitType,
          name: unitItem.name,
          nameTh: unitItem.nameTh,
          nameEng: unitItem.nameEng,
          isMain: unitItem.isMain,
          isDeleted: unitItem.isDeleted,
        };
        unitTable.unitList.push(unitModel);
      });
    }

    return unitTable;
  },
  //#endregion
  //#region account
  GetJournalTableOutput(_journalTable) {
    let journalTableList = [];
    if (_journalTable.journalTableList.length > 0) {
      _journalTable.journalTableList.forEach((journal) => {
        journalTableList.push({
          id: journal.id,
          number: journal.number,
          date: journal.date,
          totalDebit: journal.totalDebit,
          totalCredit: journal.totalCredit,
          description: journal.description,
          type: journal.type,
          status: journal.status,
          isDeleted: journal.isDeleted,
          validationStatus: journal.validationStatus,
        });
      });
    }
    return journalTableList;
  },
  GetJournalTableCountOutput(_journalCountTable) {
    let journalTableCount = {};
    if (_journalCountTable !== null) {
      journalTableCount = {
        all: _journalCountTable.all,
        awaitRecord: _journalCountTable.awaitRecord,
        draft: _journalCountTable.draft,
        awaitApprove: _journalCountTable.awaitApprove,
        purchase: _journalCountTable.purchase,
        sales: _journalCountTable.sales,
        payment: _journalCountTable.payment,
        receive: _journalCountTable.receive,
        general: _journalCountTable.general,
        voided: _journalCountTable.voided,
        shouldBeCheck: _journalCountTable.shouldBeCheck,
      };
    }
    return journalTableCount;
  },
  //#endregion
  //#region UploadDocument
  GetUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      searchText: _input.searchText,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      tableStatus: _input.tableStatus,
      uploadDocumentTableView: _input.uploadDocumentTableView,
      tableSorting: _input.tableSorting,
      sortUploadDocumentTypeIdList: _input.sortUploadDocumentTypeIdList,
      sortUploadDocumentTransactionItemTypeIdList: _input.sortUploadDocumentTransactionItemTypeIdList,
      sortFileDocumentTypeIdList: _input.sortFileDocumentTypeIdList,
    };
  },
  GetUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          fileName: transaction.fileName,
          fileType: transaction.fileType,
          fileUrl: transaction.fileUrl,
          fileFullUrl: transaction.fileFullUrl,
          id: transaction.id,
          uploadDocumentReferenceId: transaction.uploadDocumentReferenceId,
          uploadDate: transaction.uploadDate ? transaction.uploadDate.NewDateTimeUctToTimezone() : "",
          uploadDocumentReferenceNumber: transaction.uploadDocumentReferenceNumber,
          uploadDocumentReferenceType: transaction.uploadDocumentReferenceType,
          uploadDocumentReferenceTransactionItemType: transaction.uploadDocumentReferenceTransactionItemType,
          uploadDocumentTypeId: transaction.uploadDocumentTypeId,
          userId: transaction.userId,
          uploadDocumentOCRMongoId: transaction.uploadDocumentOCRMongoId,
          uploadDocumentStatusType: transaction.uploadDocumentStatusType,
          fileDocumentType: transaction.fileDocumentType,
          contactId: transaction.uploadDocumentReferenceContactId,
          uploadDocumentReferenceIssueDate: transaction.uploadDocumentReferenceIssueDate,
          disabled: transaction.uploadDocumentReferenceType > 0,
        });
      }
    }
    return transactionList;
  },
  GetInvoiceForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      transactionItemType: _input.expenseType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetQuotationForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetCreditNoteForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetDebitNoteForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetBillingNoteForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetDepositForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetReceiptForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetJournalForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetWhtForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
    };
  },
  GetRecurringTableInput(_input) {
    return {
      merchantId: userInfo.MerchantId(),
      tableSearchCriteria: {
        transactionType: _input.transactionTypeId,
        financeType: _input.financeTypeId,
        expenseType: _input.expenseTypeId,
        tableSorting: _input ? _input.tableSorting : 0,
        transactionTableView: _input ? _input.tableSorting : Enums.RecurringTableView.Id,
        pageNo: _input ? _input.pageNo : 1,
        pageSize: _input ? _input.pageSize : 10,
        searchText: _input.searchText,
      },
      isUseMainDatabase: false,
    };
  },
  GetInvoiceForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetQuotationForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetCreditNoteForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetDebitNoteForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetBillingNoteForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetDepositForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetReceiptForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetJournalForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetWhtForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  //#endregion
  //#region  Recurring
  GetRecurringTableOutput(_transactionTableList) {
    let invoice;
    if (_transactionTableList !== null) {
      invoice = {
        transactionList: RecurringTableListModel(_transactionTableList.transactionList),
        transactionCount: _transactionTableList.transactionCount,
      };
    }
    return invoice;
  },
  //#endregion
  // #region WHT
  GetWhtTableRequest(_input) {
    return {
      paymentInOutFlowType: _input.paymentInOutFlowType,
      tableStatus: _input.tableStatus,
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      searchText: _input.searchText,
      filterReceivedWht: _input.filterReceivedWht,
      sortingType: _input.sortingType,
      sortBy: _input.sortBy,
      pageNo: _input.pageNo ?? 1,
      pageSize: _input.pageSize ?? 10,
      isUseMainDatabase: _input.isUseMainDatabase,
      source: Enums.SourceTypeProject.PeakExperience,
    };
  },
  GetWhtTableCountRequest(_input) {
    return {
      paymentInOutFlowType: _input.paymentInOutFlowType,
      tableStatus: _input.tableStatus,
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      searchText: _input.searchText,
      filterReceivedWht: _input.filterReceivedWht,
      isUseMainDatabase: _input.isUseMainDatabase,
      source: Enums.SourceTypeProject.PeakExperience,
    };
  },
  GetWhtTableOutput(_tableList) {
    let tableList = [];

    if (_tableList?.length > 0) {
      for (const _table of _tableList) {
        tableList.push({
          id: _table.whtId,
          whtId: _table.whtId,
          transactionId: _table.transactionId,
          transactionType: _table.transactionType,
          transactionNumber: _table.transactionNumber,
          whtNumber: _table.whtNumber,
          contactId: _table.contactId,
          contactFullName: _table.contactFullName,
          contactBranchCode: _table.contactBranchCode,
          contactTaxId: _table.contactTaxId,
          contactCode: _table.contactCode,
          subTotalForCalculateWht: _table.subTotalForCalculateWht,
          whtDate: _table.whtDate,
          whtTotal: _table.whtTotal,
          whtAmountType: _table.whtAmountType,
          isReceivedWht: _table.isReceivedWht,
          isDeleted: _table.isDeleted,
          whtCertificateId: _table.whtCertificateId,
          eWhtType: _table.eWhtType,
        });
      }
    }

    return tableList;
  },
  // #endregion
  GetUserTableOutput(input) {
    return input
      ? {
          isHaveSupportUser: input.isHaveSupportUser,
          userTableDetails: input.userTableDetails ? input.userTableDetails : [],
          allUserCount: input.alluserCount,
          lastestUpdateDatetime: input.lastestUpdateDatetime,
        }
      : {
          isHaveSupportUser: false,
          userTableDetails: [],
          allUserCount: 0,
        };
  },
  GetUserRoleTableOutput(input) {
    return {
      roleTableDetails: input && input.roleTableDetails ? input.roleTableDetails : [],
      roleCount: input ? input.roleCount : 0,
    };
  },
  GetUserInvitationTableOutput(input) {
    return {
      invitationTableDetails: input && input.invitationTableDetails ? input.invitationTableDetails : [],
      invitationCount: input ? input.invitationCount : 0,
    };
  },
  GetAllocationTable(_table) {
    let table = {
      allocationTable: [],
      allcationCount: 0,
    };
    if (_table && _table.tableList !== null && _table.tableList.length > 0) {
      _table.tableList.forEach((element) => {
        table.allocationTable.push({
          id: element.id,
          number: element.number,
          name: element.name,
          allocationDocumentFinanceType: element.allocationDocumentFinanceType,
          isArchived: element.isArchived,
          allocationItemCount: element.allocationItemCount,
        });
      });
      table.allcationCount = _table.tableCount > 0 ? _table.tableCount : 0;
    }
    return table;
  },
  ConvertToUnpaidInvoiceList(_invoiceList) {
    let invoiceList = [];
    if (_invoiceList && _invoiceList.length > 0) {
      _invoiceList.forEach((element) => {
        invoiceList.push({
          id: element.id,
          contactId: element.contactId,
          dueDate: element.dueDate,
          issueDate: element.issueDate,
          invoiceNumber: element.invoiceNumber,
          isCreatedTaxInvoice: element.isCreatedTaxInvoice,
          transactionSummaryModel: TransactionSummaryModel(element.transactionSummaryModel),
        });
      });
    }
    return invoiceList;
  },
  ConvertToSubscriptionHistoryTable(_subscriptionHistoryTable) {
    let subscriptionHistoryTableDetail = [];
    if (
      _subscriptionHistoryTable.subscriptionHistoryRowModelList &&
      _subscriptionHistoryTable.subscriptionHistoryRowModelList.length > 0
    ) {
      _subscriptionHistoryTable.subscriptionHistoryRowModelList.forEach((subscriptionHistoryTable) => {
        subscriptionHistoryTableDetail.push({
          createDateTime: subscriptionHistoryTable.createDateTime,
          displayName: subscriptionHistoryTable.displayName,
          isCancelled: subscriptionHistoryTable.isCancelled,
          referenceMerchantId: subscriptionHistoryTable.referenceMerchantId,
          referenceMerchantName: subscriptionHistoryTable.referenceMerchantName,
          netAmount: subscriptionHistoryTable.netAmount,
          paymentGatewayType: subscriptionHistoryTable.paymentGatewayType,
          statusDetail: packageHelper.GetPaymentStatusDetail(subscriptionHistoryTable),
          paymentStatus: subscriptionHistoryTable.paymentStatus,
          peakPackage: subscriptionHistoryTable.peakPackage,
          peakPaymentConnectRefId: subscriptionHistoryTable.peakPaymentConnectRefId,
          peakPaymentConnectV2Id: subscriptionHistoryTable.peakPaymentConnectV2Id,
          peakpaymentConnectv2SwapId: subscriptionHistoryTable.peakpaymentConnectv2SwapId,
          puunMerchantId: subscriptionHistoryTable.puunMerchantId,
          puunReceiptId: subscriptionHistoryTable.puunReceiptId,
          receiptNumber: subscriptionHistoryTable.receiptNumber,
          status: subscriptionHistoryTable.status,
          updatedPeakerId: subscriptionHistoryTable.updatedPeakerId,
          receiptDate: subscriptionHistoryTable.receiptDate,
          isHaveWHT: subscriptionHistoryTable.isHaveWHT,
          subscriptionHistoryActionType: subscriptionHistoryTable.subscriptionHistoryActionType,
          campaignDescription: subscriptionHistoryTable.campaignDescription,
          peakPaymentConnectV2Month: subscriptionHistoryTable.peakPaymentConnectV2Month,
          expireDateTime: subscriptionHistoryTable.expireDateTime,
          isReceivedWht: subscriptionHistoryTable.isReceivedWht,
          whtFileName: subscriptionHistoryTable.whtFileName,
        });
      });
    }
    return {
      tableList: subscriptionHistoryTableDetail,
      rowCountAll: _subscriptionHistoryTable.rowCountAll,
    };
  },
  ConvertToInvoiceForCreateBillingNoteTable(_transactionTableList) {
    let invoice;
    if (_transactionTableList !== null) {
      invoice = {
        pageNo: _transactionTableList.pageNo,
        pageSize: _transactionTableList.pageSize,
        transactionList: this.ConvertToInvoiceForCreateBillingNote(
          _transactionTableList.invoiceForCreateBillingNoteDetailRowList
        ),
        transactionCount: _transactionTableList.totalCount,
      };
    }
    return invoice;
  },
  ConvertToInvoiceForCreateBillingNote(_transactionTableRowList) {
    let invoiceList = [];
    if (_transactionTableRowList && _transactionTableRowList.length > 0) {
      _transactionTableRowList.forEach((_invoice, index) => {
        invoiceList.push({
          id: _invoice.invoiceId,
          invoiceId: _invoice.invoiceId,
          invoiceNumber: _invoice.invoiceNumber,
          invoiceDate: _invoice.invoiceDate,
          invoiceDueDate: _invoice.invoiceDueDate,
          invoiceNetAmount: _invoice.invoiceNetAmount,
          amountToPay: _invoice.amountToPay,
          whtAmount: _invoice.whtAmount,
          currencyRatio: _invoice.currencyRatio,
          fromCurrencyUid: _invoice.fromCurrencyUid,
          toCurrencyUid: _invoice.toCurrencyUid,
          creditNoteList: [],
          remainPaymentAmount: _invoice.remainPaymentAmount,
          remainCurrencyPaymentNetAmount: _invoice.remainCurrencyPaymentNetAmount,
          remainWhtPaymentNetAmount: _invoice.remainWhtPaymentNetAmount,
          isServiceOnly: _invoice.isServiceOnly,
          isNoneOrNotSpecifyWht: _invoice.isNoneOrNotSpecifyWht,
          sameProductVatType: _invoice.sameProductVatType,
          billingAmountError: false,
          check: false,
          referenceTransactionId: _invoice.invoiceId,
          billedAmount: _invoice.remainCurrencyPaymentNetAmount.FormatMoney(),
          invoiceCurrencyNetAmount: _invoice.invoiceCurrencyNetAmount,
          invoiceCurrencyZeroVatTotal: _invoice.invoiceCurrencyZeroVatTotal,
          invoiceCurrencyPreVatTotal: _invoice.invoiceCurrencyPreVatTotal,
          invoiceCurrencySubTotalForCalculateWht: _invoice.invoiceCurrencySubTotalForCalculateWht,
          invoiceCurrencyWhtTotal: _invoice.invoiceCurrencyWhtTotal,
          invoiceCurrencyExchangeRates: _invoice.invoiceCurrencyExchangeRates,
          invoiceCurrencyRatio: _invoice.invoiceCurrencyRatio,
          invoiceCurrencyVatExemptedTotal: _invoice.invoiceCurrencyVatExemptedTotal,
          invoiceCurrencyVatTotal: _invoice.invoiceCurrencyVatTotal,
          invoiceVatExemptedTotal: _invoice.invoiceVatExemptedTotal,
          invoiceZeroVatTotal: _invoice.invoiceZeroVatTotal,
          invoicePreVatTotal: _invoice.invoicePreVatTotal,
          invoiceVatTotal: _invoice.invoiceVatTotal,
          invoiceWhtTotal: _invoice.invoiceWhtTotal,
          invoiceSubTotalForCalculateWht: _invoice.invoiceSubTotalForCalculateWht,
          invoiceWithCreditNoteNetAmount: _invoice.invoiceWithCreditNoteNetAmount,
          invoiceCurrencyWithCreditNoteNetAmount: _invoice.invoiceCurrencyWithCreditNoteNetAmount,
        });
        if (_invoice.creditNoteList && _invoice.creditNoteList.length > 0) {
          _invoice.creditNoteList.forEach((creditNote) => {
            invoiceList[index].creditNoteList.push({
              id: creditNote.creditNoteId,
              isAllNoneOrNotSpecifyWht: creditNote.creditNoteIsAllNoneOrNotSpecifyWht,
              creditNoteAmount: creditNote.creditNoteAmount,
              transactionDate: new Date(creditNote.creditNoteIssueDate).GetDateFormat(),
              transactionId: creditNote.creditNoteId,
              transactionNetAmount: creditNote.creditNoteNetAmount,
              transactionNumber: creditNote.creditNoteNumber,
              whtAmount: creditNote.whtAmount,
            });
          });
        }
      });
    }
    return invoiceList;
  },
  GetSummaryTableBankStatementParams(input) {
    const params = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return params;
  },
  GetBankReconciledByBankAccountIdParams(input) {
    const params = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      isOrderDesc: true,
    };

    return params;
  },
  GetInvoiceTableRequest(input) {
    return GetInvoiceTableRequest(input);
  },
  GetInvoiceTableAdvanceSearchRequest(input) {
    return GetInvoiceTableAdvanceSearchRequest(input);
  },
  GetInvoiceTableVeryAdvanceSearchRequest(input) {
    return GetInvoiceTableVeryAdvanceSearchRequest(input);
  },
  GetInvoiceTableCountRequest(input) {
    return GetInvoiceTableCountRequest(input);
  },
  GetInvoiceTableCountAdvanceSearchRequest(input) {
    return GetInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetInvoiceTableCountVeryAdvanceSearchRequest(input) {
    return GetInvoiceTableCountVeryAdvanceSearchRequest(input);
  },
  GetExpenseTableRequest(input) {
    return this.GetInvoiceTableRequest(input);
  },
  GetExpenseTableAdvanceSearchRequest(input) {
    return this.GetInvoiceTableAdvanceSearchRequest(input);
  },
  GetExpenseTableVeryAdvanceSearchRequest(input) {
    return GetExpenseTableVeryAdvanceSearchRequest(input);
  },
  GetExpenseTableCountRequest(input) {
    return this.GetInvoiceTableCountRequest(input);
  },
  GetExpenseTableCountAdvanceSearchRequest(input) {
    return this.GetInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetExpenseTableCountVeryAdvanceSearchRequest(input) {
    return GetExpenseTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableRequest(input) {
    return this.GetExpenseTableRequest(input);
  },
  GetPurchaseAssetTableAdvanceSearchRequest(input) {
    return this.GetExpenseTableAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableVeryAdvanceSearchRequest(input) {
    return GetPurchaseAssetTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableCountRequest(input) {
    return this.GetExpenseTableCountRequest(input);
  },
  GetPurchaseAssetTableCountAdvanceSearchRequest(input) {
    return this.GetExpenseTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input) {
    return GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input);
  },
  GetInvoiceTableOutput(table) {
    return GetInvoiceTableOutput(table);
  },
  GetQuotationTableRequest(input) {
    return GetQuotationTableRequest(input);
  },
  GetQuotationTableAdvanceSearchRequest(input) {
    return GetQuotationTableAdvanceSearchRequest(input);
  },
  GetQuotationTableVeryAdvanceSearchRequest(input) {
    return GetQuotationTableVeryAdvanceSearchRequest(input);
  },
  GetQuotationTableCountRequest(input) {
    return GetQuotationTableCountRequest(input);
  },
  GetQuotationTableCountAdvanceSearchRequest(input) {
    return GetQuotationTableCountAdvanceSearchRequest(input);
  },
  GetQuotationTableCountVeryAdvanceSearchRequest(input) {
    return GetQuotationTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableRequest(input) {
    return this.GetQuotationTableRequest(input);
  },
  GetPurchaseOrderTableAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableCountRequest(input) {
    return this.GetQuotationTableCountRequest(input);
  },
  GetPurchaseOrderTableCountAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableRequest(input) {
    return this.GetPurchaseOrderTableRequest(input);
  },
  GetPurchaseOrderAssetTableAdvanceSearchRequest(input) {
    return this.GetPurchaseOrderTableAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableCountRequest(input) {
    return this.GetPurchaseOrderTableCountRequest(input);
  },
  GetPurchaseOrderAssetTableCountAdvanceSearchRequest(input) {
    return this.GetPurchaseOrderTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input);
  },
  GetQuotationTableOutput(table) {
    return GetQuotationTableOutput(table);
  },
  GetReceiptTableRequest(input) {
    return GetReceiptTableRequest(input);
  },
  GetReceiptTableAdvanceSearchRequest(input) {
    return GetReceiptTableAdvanceSearchRequest(input);
  },
  GetReceiptTableVeryAdvanceSearchRequest(input) {
    return GetReceiptTableVeryAdvanceSearchRequest(input);
  },
  GetReceiptTableCountRequest(input) {
    return GetReceiptTableCountRequest(input);
  },
  GetReceiptTableCountAdvanceSearchRequest(input) {
    return GetReceiptTableCountAdvanceSearchRequest(input);
  },
  GetReceiptTableCountVeryAdvanceSearchRequest(input) {
    return GetReceiptTableCountVeryAdvanceSearchRequest(input);
  },
  GetReceiptTableOutput(table) {
    return GetReceiptTableOutput(table);
  },
  GetTaxInvoiceTableRequest(input) {
    return GetTaxInvoiceTableRequest(input);
  },
  GetTaxInvoiceTableAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableVeryAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableVeryAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableCountRequest(input) {
    return GetTaxInvoiceTableCountRequest(input);
  },
  GetTaxInvoiceTableCountAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableRequest(input) {
    return this.GetTaxInvoiceTableRequest(input);
  },
  GetPurchaseTaxInvoiceTableAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableVeryAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableCountRequest(input) {
    return this.GetTaxInvoiceTableCountRequest(input);
  },
  GetPurchaseTaxInvoiceTableCountAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableCountVeryAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableOutput(table) {
    return GetTaxInvoiceTableOutput(table);
  },
  GetCreditNoteTableRequest(input) {
    return GetCreditNoteTableRequest(input);
  },
  GetCreditNoteTableAdvanceSearchRequest(input) {
    return GetCreditNoteTableAdvanceSearchRequest(input);
  },
  GetCreditNoteTableVeryAdvanceSearchRequest(input) {
    return GetCreditNoteTableVeryAdvanceSearchRequest(input);
  },
  GetCreditNoteTableCountRequest(input) {
    return GetCreditNoteTableCountRequest(input);
  },
  GetCreditNoteTableCountAdvanceSearchRequest(input) {
    return GetCreditNoteTableCountAdvanceSearchRequest(input);
  },
  GetCreditNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetCreditNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableRequest(input) {
    return this.GetCreditNoteTableRequest(input);
  },
  GetReceivedCreditNoteTableAdvanceSearchRequest(input) {
    return this.GetCreditNoteTableAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input) {
    return GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableCountRequest(input) {
    return this.GetCreditNoteTableCountRequest(input);
  },
  GetReceivedCreditNoteTableCountAdvanceSearchRequest(input) {
    return this.GetCreditNoteTableCountAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetCreditNoteTableOutput(table) {
    return GetCreditNoteTableOutput(table);
  },
  GetDebitNoteTableRequest(input) {
    return GetDebitNoteTableRequest(input);
  },
  GetDebitNoteTableAdvanceSearchRequest(input) {
    return GetDebitNoteTableAdvanceSearchRequest(input);
  },
  GetDebitNoteTableVeryAdvanceSearchRequest(input) {
    return GetDebitNoteTableVeryAdvanceSearchRequest(input);
  },
  GetDebitNoteTableCountRequest(input) {
    return GetDebitNoteTableCountRequest(input);
  },
  GetDebitNoteTableCountAdvanceSearchRequest(input) {
    return GetDebitNoteTableCountAdvanceSearchRequest(input);
  },
  GetDebitNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetDebitNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableRequest(input) {
    return this.GetDebitNoteTableRequest(input);
  },
  GetReceivedDebitNoteTableAdvanceSearchRequest(input) {
    return this.GetDebitNoteTableAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input) {
    return GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableCountRequest(input) {
    return this.GetDebitNoteTableCountRequest(input);
  },
  GetReceivedDebitNoteTableCountAdvanceSearchRequest(input) {
    return this.GetDebitNoteTableCountAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetDebitNoteTableOutput(table) {
    return GetDebitNoteTableOutput(table);
  },
  GetBillingNoteTableRequest(input) {
    return GetBillingNoteTableRequest(input);
  },
  GetBillingNoteTableAdvanceSearchRequest(input) {
    return GetBillingNoteTableAdvanceSearchRequest(input);
  },
  GetBillingNoteTableVeryAdvanceSearchRequest(input) {
    return GetBillingNoteTableVeryAdvanceSearchRequest(input);
  },
  GetBillingNoteTableCountRequest(input) {
    return GetBillingNoteTableCountRequest(input);
  },
  GetBillingNoteTableCountAdvanceSearchRequest(input) {
    return GetBillingNoteTableCountAdvanceSearchRequest(input);
  },
  GetBillingNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetBillingNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableRequest(input) {
    return this.GetBillingNoteTableRequest(input);
  },
  GetCombinePaymentNoteTableAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableVeryAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableVeryAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableCountRequest(input) {
    return this.GetBillingNoteTableCountRequest(input);
  },
  GetCombinePaymentNoteTableCountAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableCountAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableCountVeryAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetBillingNoteTableOutput(table) {
    return GetBillingNoteTableOutput(table);
  },
  GetQuotationReferenceInvoiceListOutput(_quotationReferenceInvoiceList) {
    return GetQuotationReferenceInvoiceListOutput(_quotationReferenceInvoiceList);
  },
  GetStockActivityTableRequest(input) {
    return GetStockActivityTableRequest(input);
  },
  GetStockActivityTableCountRequest(input) {
    return GetStockActivityTableCountRequest(input);
  },
  GetStockActivityTableOutput(tableList, isShowRemain) {
    return GetStockActivityTableOutput(tableList, isShowRemain);
  },
  //
  GetJournalTableRequest(input) {
    return GetJournalTableRequest(input);
  },
  GetJournalTableAdvanceSearchRequest(input) {
    return GetJournalTableAdvanceSearchRequest(input);
  },
  GetJournalTableVeryAdvanceSearchRequest(input) {
    return GetJournalTableVeryAdvanceSearchRequest(input);
  },
  GetJournalTableCountRequest(input) {
    return GetJournalTableCountRequest(input);
  },
  GetJournalTableCountAdvanceSearchRequest(input) {
    return GetJournalTableCountAdvanceSearchRequest(input);
  },
  GetJournalTableCountVeryAdvanceSearchRequest(input) {
    return GetJournalTableCountVeryAdvanceSearchRequest(input);
  },
  GetJournalTableOutput(table) {
    return GetJournalTableOutput(table);
  },
  GetLotTableOutput(lot) {
    return GetLotTableOutput(lot);
  },
  GetDepositTableListOutput(table) {
    return GetDepositTableListOutput(table);
  },
  GetSettingTableOutput(_settingTableQuotation, documentType) {
    return GetSettingTableOutput(_settingTableQuotation, documentType);
  },
  GetUpdateSettingTableRequest(input, documentType) {
    return GetUpdateSettingTableRequest(input, documentType);
  },
};
